import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Coins({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M3 9C3 10.1 5.23 11 8 11M8 15C5.239 15 3 14.1 3 13M12.99 5V8M11 16C11 17.1 13.23 18 16 18C18.76 18 21 17.1 21 16M11 12C11 13.1 13.23 14 16 14C18.76 14 21 13.1 21 12V20C21 21.1 18.76 22 16 22C13.23 22 11 21.1 11 20V12ZM11 12C11 10.89 13.24 10 16 10C18.76 10 21 10.89 20.99 12M8 19C5.239 19 3 18.1 3 17V5M3 5C3 4.46957 3.52678 3.96086 4.46447 3.58579C5.40215 3.21071 6.67392 3 8 3C9.32608 3 10.5979 3.21071 11.5355 3.58579C12.4732 3.96086 13 4.46957 13 5C13 5.53043 12.4732 6.03914 11.5355 6.41421C10.5979 6.78929 9.32608 7 8 7C6.67392 7 5.40215 6.78929 4.46447 6.41421C3.52678 6.03914 3 5.53043 3 5Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default Coins;